export const MODULOS = {
  COMPARTIDO: 'Compartido',
  SISTEMA: 'Sistema',
  NOTIFICACIONES: 'Notificaciones',
  CATALOGO: 'Catalogo',
  CLIENTES: 'Clientes',
  CONTABILIDAD: 'Contabilidad',
  DIAN: 'Dian',
  GESTION_INMOBILIARIA: 'GestionInmobiliaria',
  INVENTARIO: 'Inventario',
  TRANSPORTE_CARGA: 'TransporteCarga',
  VENTAS: 'Ventas',
  GESTOR_INCIDENTES: 'GestorIncidentes',
  REPORTES: 'Reportes',
  TERCEROS: 'Terceros'
};